import cx from 'classnames'
import _ from 'lodash'
import { connect } from 'react-redux'
import styles from './RankingTable.css'
import { dollarFormat, numeralFormat } from '../../../../../../lib/renderUtil'
import { pullLeft, pullRight } from '../../../../../styles/shared.css'
import { HyperLink } from '../../../../Common/Form'
import CommonRankingTable from '../../../../Common/NewDashboard/Table/RankingTable/RankingTable'
import TooltipIcon from '../../../../Common/TooltipIcon/TooltipIcon'
import { EMPTY_VALUE } from '../../../../../constants/globalTypes'
import confUtil from '../../../../../../lib/confUtil'

export const FIELD = {
  LISTING_ID: 'listingId',
  NAME: 'name',
  SOLD_AMOUNT: 'soldAmount',
  SOLD_QUANTITY: 'soldQuantity',
  PAGE_VIEW: 'pageView',
  CONVERSION_RATE: 'conversionRate',
  UNIQUE_USER: 'uniqueUser',
  AVAILABLE_QUANTITY: 'availableQuantity',
  PRICE: 'price'
}

export const FIELD_MAP = {
  [FIELD.LISTING_ID]: '賣場編號',
  [FIELD.NAME]: '賣場名稱',
  [FIELD.SOLD_AMOUNT]: '訂購金額',
  [FIELD.SOLD_QUANTITY]: '訂購量',
  [FIELD.PAGE_VIEW]: '瀏覽量',
  [FIELD.CONVERSION_RATE]: '轉換率(%)',
  [FIELD.UNIQUE_USER]: '訪客數',
  [FIELD.AVAILABLE_QUANTITY]: '可訂購量',
  [FIELD.PRICE]: '目前售價'
}

const getColumns = (buyGdSaleUrl) => [
  {
    id: 'listingAndName',
    accessor: rowData => _.pick(rowData, [FIELD.LISTING_ID, FIELD.NAME]),
    minWidth: 120,
    headerClassName: cx(pullLeft, styles.listingAndNameCol),
    className: cx(pullLeft, styles.listingAndNameCol),
    Header: () => (
      <>
        {FIELD_MAP[FIELD.LISTING_ID]}
        <br />
        {FIELD_MAP[FIELD.NAME]}
      </>
    ),
    Cell: row => {
      const listingId = _.get(row, 'value.listingId', '')
      const name = _.get(row, 'value.name', '')
      return (
        <>
          <p className={styles.listingId}>
            <HyperLink
              target='_blank'
              href={`${buyGdSaleUrl}?gdid=${listingId}`}
            >
              {listingId}
            </HyperLink>
          </p>
          <p className={styles.listingName}>
            {name}
          </p>
        </>
      )
    }
  },
  {
    id: FIELD.SOLD_AMOUNT,
    accessor: FIELD.SOLD_AMOUNT,
    width: 120,
    Header: FIELD_MAP[FIELD.SOLD_AMOUNT],
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => dollarFormat(row.value)
  },
  {
    id: FIELD.SOLD_QUANTITY,
    accessor: FIELD.SOLD_QUANTITY,
    width: 100,
    Header: FIELD_MAP[FIELD.SOLD_QUANTITY],
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    id: FIELD.PAGE_VIEW,
    accessor: FIELD.PAGE_VIEW,
    width: 100,
    Header: () => (
      <>
        {FIELD_MAP[FIELD.PAGE_VIEW]}
        <TooltipIcon tooltipTitle='賣場被點開的次數' />
      </>
    ),
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    id: FIELD.CONVERSION_RATE,
    accessor: FIELD.CONVERSION_RATE,
    width: 120,
    Header: () => (
      <>
        {FIELD_MAP[FIELD.CONVERSION_RATE]}
        <TooltipIcon tooltipTitle='訂購量/瀏覽量(%)' />
      </>
    ),
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => {
      const { original } = row
      const pageView = _.get(original, FIELD.PAGE_VIEW, 0)

      if (pageView === 0) {
        return EMPTY_VALUE
      }

      return _.isNil(row.value) ? EMPTY_VALUE : `${(row.value * 100).toFixed(2)}%`
    }
  },
  {
    id: FIELD.UNIQUE_USER,
    accessor: FIELD.UNIQUE_USER,
    width: 100,
    Header: () => (
      <>
        {FIELD_MAP[FIELD.UNIQUE_USER]}
        <TooltipIcon tooltipTitle='區間訪客為每小時不重複訪客數加總' />
      </>
    ),
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    id: FIELD.AVAILABLE_QUANTITY,
    accessor: FIELD.AVAILABLE_QUANTITY,
    width: 100,
    Header: FIELD_MAP[FIELD.AVAILABLE_QUANTITY],
    headerClassName: cx(pullRight, styles.col),
    className: cx(pullRight, styles.col),
    Cell: row => numeralFormat(row.value, { allowZero: true })
  },
  {
    id: FIELD.PRICE,
    accessor: FIELD.PRICE,
    width: 100,
    Header: FIELD_MAP[FIELD.PRICE],
    headerClassName: cx(pullRight, styles.col, styles.lastCol),
    className: cx(pullRight, styles.col, styles.lastCol),
    Cell: row => dollarFormat(row.value)
  }
]

const RankingTable = (props) => {
  const {
    data,
    rankingColumnProps,
    noFoundDescription,
    showPagination,
    readmoreProps = {},
    paginationProps = {},
    envConf = {}
  } = props

  const buyGdSaleUrl = confUtil.getAbsUrl(envConf)('buyGdSale')

  return (
    <CommonRankingTable
      sortable={false}
      resizable={false}
      showPagination={showPagination}
      data={data}
      columns={getColumns(buyGdSaleUrl)}
      noDataText={noFoundDescription}
      readmoreProps={readmoreProps}
      rankingColumnProps={rankingColumnProps}
      paginationProps={paginationProps}
    />
  )
}

const mapStateToProps = (state) => {
  const envConf = _.get(state, 'page.envConf', {})
  return {
    envConf
  }
}

export default connect(mapStateToProps)(RankingTable)
